export const initAcfFormInteractions = ($) => {
  $(() => {
    const inputSelector = '.acf-input input, .acf-input textarea, .acf-input select';
    const $inputs = $(inputSelector);

    const hasInputValue = ($el) => {
      const type = ($el.attr('type') || '').toLowerCase();
      if (type === 'hidden') return false;
      if (type === 'checkbox' || type === 'radio') {
        return $el.is(':checked');
      }
      return !!$el.val();
    };

    const resetFileFieldsForNewPosts = () => {
      $('.acf-field-file').each(function () {
        const $field = $(this);
        const $fileUploader = $field.find('.acf-file-uploader');
        const $hiddenInput = $field.find('input[type="hidden"][data-name="id"]');
        const $fileInput = $field.find('input[type="file"]');

        const $form = $field.closest('form');
        const postId = $form.find('input[name="post_id"]').val() || $form.find('input[name="_acf_post_id"]').val();

        if (postId === 'new' || postId === '0' || !postId) {
          if ($hiddenInput.length && $hiddenInput.val()) {
            $hiddenInput.val('');
          }
          if ($fileInput.length) {
            $fileInput.val('');
          }
          $fileUploader.removeClass('has-value');
          $fileUploader.find('.show-if-value').hide();
          $fileUploader.find('.hide-if-value').show();
        }
      });
    };

    const applyFilledState = ($el) => {
      const $field = $el.closest('.acf-field');
      if (hasInputValue($el)) {
        $field.addClass('input_filled');
      } else {
        $field.removeClass('input_filled');
      }
    };

    const bindInputEvents = ($context = $(document)) => {
      $context.on('focusin', inputSelector, function () {
        $(this).closest('.acf-field').addClass('input_focus');
      });

      $context.on('focusout', inputSelector, function () {
        $(this).closest('.acf-field').removeClass('input_focus');
      });

      $context.on('change', inputSelector, function () {
        const $el = $(this);
        applyFilledState($el);

        if ($el.parent().hasClass('acf-basic-uploader')) {
          let val = $el.val();
          val = val.replace('C:\\fakepath\\', '');
          const $label = $el.closest('.acf-field').find('.acf-label > label');
          const $uploader = $el.parent('.acf-basic-uploader');

          // Update label text
          $label.html(val);
          $label.addClass('filled_file');

          // Update uploader data attributes for styling
          if (val) {
            $uploader.addClass('has-file').attr('data-filename', val);
          } else {
            $uploader.removeClass('has-file').removeAttr('data-filename');
          }
        }
      });
    };

    const initDescriptionTooltips = ($context = $(document)) => {
      $context.find('.acf-form .acf-field').each(function () {
        const $field = $(this);

        // Avoid double-initialisation.
        if ($field.data('has-tooltip')) {
          return;
        }

        const $label = $field.find('> .acf-label > label').first();
        if (!$label.length) {
          return;
        }

        // ACF usually outputs descriptions either under the label or under the input.
        const $description =
          $field.find('> .acf-label > .description').first().length
            ? $field.find('> .acf-label > .description').first()
            : $field.find('> .acf-input > .description').first();

        if (!$description.length) {
          return;
        }

        const text = $.trim($description.text());
        if (!text) {
          return;
        }

        // Mark as processed before DOM changes to avoid loops.
        $field.data('has-tooltip', true);
        $field.addClass('acf-has-tooltip');

        // Hide native description so we control layout fully.
        $description.hide();

        const tooltipId = `acf-tooltip-${Math.random().toString(36).slice(2)}`;

        const $trigger = $(`
          <button
            type="button"
            class="acf-tooltip-trigger"
          >
            <span class="acf-tooltip-trigger__icon">i</span>
          </button>
        `);

        const $tooltip = $(`
          <div id="${tooltipId}" class="acf-tooltip-bubble" role="tooltip">
            ${text}
          </div>
        `);

        // Place icon in the label…
        $label.append($trigger);

        // …and always append the tooltip bubble to the field itself.
        $field.append($tooltip);

        // Show tooltip ONLY when hovering/focusing the i icon.
        $trigger.on('mouseenter focus', function () {
          // Horizontal positioning: align tooltip triangle over the icon.
          const fieldOffset = $field.offset();
          const triggerOffset = $trigger.offset();

          if (fieldOffset && triggerOffset) {
            const fieldWidth = $field.outerWidth();
            const bubbleWidth = $tooltip.outerWidth();
            const triggerCenter =
              triggerOffset.left - fieldOffset.left + $trigger.outerWidth() / 2;

            // Center bubble on trigger, clamped within the field.
            let left = triggerCenter - bubbleWidth / 2;
            left = Math.max(0, Math.min(left, fieldWidth - bubbleWidth));

            // Set bubble left
            $tooltip.css('left', `${left}px`);

            // Position triangle over the icon, even when bubble is clamped.
            const bubbleLeftEdge = left;
            let pointerPercent = ((triggerCenter - bubbleLeftEdge) / bubbleWidth) * 100;
            pointerPercent = Math.max(0, Math.min(100, pointerPercent));
            $tooltip.css('--acf-tooltip-pointer-x', `${pointerPercent}%`);
          }

          $tooltip.addClass('is-visible');
        });

        $trigger.on('mouseleave blur', function () {
          $tooltip.removeClass('is-visible');
        });

      });
    };

    // Initial bindings (delegated)
    bindInputEvents();
    initDescriptionTooltips();

    // Single global handler: when user focuses/clicks any ACF field,
    // clear inline ACF error markup to avoid layout jumps from
    // dynamic .acf-error-message / .acf-notice elements.
    $(document).on('focusin click', '.acf-form .acf-field', function () {
      const $field = $(this);
      $field.removeClass('acf-error');
      $field.find('.acf-error-message, .acf-notice.-error').remove();
    });

    // Set initial filled state on page load (e.g., when navigating back)
    $inputs.each(function () {
      applyFilledState($(this));
    });

    // Initialise Select2 on ACF select fields (if Select2 is available)
    if ($.fn.select2) {
      const $select2Fields = $('.acf-field-select select, .acf-field[data-type="select"] select');

      $select2Fields.each(function () {
        const $select = $(this);

        // Avoid double-initialisation
        if (!$select.hasClass('select2-hidden-accessible')) {
          $select.select2();
        }

        const $field = $select.closest('.acf-field');

        // Keep focus state in sync with Select2 open / close
        $select.on('select2:open', () => {
          $field.addClass('input_focus');
        });

        $select.on('select2:close', () => {
          $field.removeClass('input_focus');
        });

        // Ensure filled state reflects initial value
        if ($select.val()) {
          $field.addClass('input_filled');
        }
      });
    }

    // Clear file fields on page load (for new posts)
    resetFileFieldsForNewPosts();

    // Handle file upload fields with basic uploader
    $('.acf-field-file').each(function () {
      const $field = $(this);
      const $basicUploader = $field.find('.acf-basic-uploader');
      const labelText = $field.find('.acf-label > label').text().trim();

      if ($basicUploader.length) {
        const $fileInput = $basicUploader.find('input[type="file"]');

        // Store label text for styling
        $basicUploader.attr('data-label', labelText);

        // Handle clicks on the uploader (the whole label)
        $basicUploader.on('click', function (e) {
          if (!$(e.target).is('input[type="file"]')) {
            $field.addClass('input_focus');
            // Open the file picker when clicking anywhere on the pill
            if ($fileInput.length) {
              e.preventDefault();
              $fileInput.trigger('click');
            }
          }
        });

        // Handle file input clicks
        $fileInput.on('click', function (e) {
          e.stopPropagation();
          $field.addClass('input_focus');
        });
      }
    });

    // Make the entire "add file" pill open the native file picker (not just the icon)
    $(document).on('click', '.acf-field-file .hide-if-value p', function (e) {
      const $field = $(this).closest('.acf-field-file');
      const $basicInput = $field.find('.acf-basic-uploader input[type="file"]');

      if ($basicInput.length) {
        e.preventDefault();
        $basicInput.trigger('click');
      }
    });

    // Allow clicking the selected-file pill to re-open the file picker (except on the remove icon)
    $(document).on('click', '.acf-field-file .show-if-value .file-wrap', function (e) {
      if ($(e.target).closest('.acf-icon').length) return;
      const $field = $(this).closest('.acf-field-file');
      const $basicInput = $field.find('.acf-basic-uploader input[type="file"]');
      if ($basicInput.length) {
        e.preventDefault();
        $basicInput.trigger('click');
      }
    });

    // Re-run initial states when returning via browser back/forward (bfcache)
    $(window).on('pageshow', function (event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        resetFileFieldsForNewPosts();
        $inputs.each(function () {
          const $field = $(this).closest('.acf-field');
          if (hasInputValue($(this))) {
            $field.addClass('input_filled');
          } else {
            $field.removeClass('input_filled');
          }
        });
      }
    });

    // Restrict phone fields to numbers and + only
    // Apply to all phone field variations: phone, applicant_phone_private, applicant_phone_work, spouse_phone_private, spouse_phone_work
    const phoneFieldNames = ['phone', 'applicant_phone_private', 'applicant_phone_work', 'spouse_phone_private', 'spouse_phone_work'];

    // Build selector for all phone fields by data-name
    const phoneFieldSelector = phoneFieldNames.map(name => `.acf-field[data-name="${name}"] input[type="text"]`).join(', ');

    // Also find phone fields by label text (fallback)
    const findPhoneFieldsByLabel = function() {
      $('.acf-field').each(function() {
        const $field = $(this);
        const $label = $field.find('label');
        if ($label.length && $label.text().toLowerCase().indexOf('téléphone') !== -1) {
          const $input = $field.find('input[type="text"]');
          if ($input.length && !$input.data('phone-restricted')) {
            restrictPhoneInput($input);
          }
        }
      });
    };

    // Function to clean phone input value
    const cleanPhoneValue = function(value) {
      return value.replace(/[^0-9+]/g, '');
    };

    // Function to restrict phone input
    const restrictPhoneInput = function($input) {
      if ($input.data('phone-restricted')) {
        return; // Already restricted
      }
      $input.data('phone-restricted', true);

      // Prevent invalid characters on keypress
      $input.on('keypress', function(e) {
        // Allow control keys (backspace, delete, tab, escape, enter, arrow keys, etc.)
        if (e.ctrlKey || e.metaKey || e.altKey || e.keyCode === 8 || e.keyCode === 9 ||
            e.keyCode === 13 || e.keyCode === 27 || (e.keyCode >= 35 && e.keyCode <= 40)) {
          return true;
        }

        // Allow only numbers and +
        const char = String.fromCharCode(e.which || e.keyCode);
        if (!/[0-9+]/.test(char)) {
          e.preventDefault();
          return false;
        }
      });

      // Clean on input
      $input.on('input', function() {
        const $this = $(this);
        let value = $this.val();
        const cleaned = cleanPhoneValue(value);
        if (value !== cleaned) {
          $this.val(cleaned);
        }
      });

      // Clean on paste
      $input.on('paste', function() {
        const $input = $(this);
        setTimeout(() => {
          let value = $input.val();
          const cleaned = cleanPhoneValue(value);
          if (value !== cleaned) {
            $input.val(cleaned);
          }
        }, 0);
      });
    };

    // Apply to existing phone fields
    $(phoneFieldSelector).each(function() {
      restrictPhoneInput($(this));
    });

    // Also find phone fields by label text (fallback)
    findPhoneFieldsByLabel();

    // Use event delegation for dynamically added fields (repeaters, etc.)
    $(document).on('keypress', phoneFieldSelector, function(e) {
      // Allow control keys (backspace, delete, tab, escape, enter, arrow keys, etc.)
      if (e.ctrlKey || e.metaKey || e.altKey || e.keyCode === 8 || e.keyCode === 9 ||
          e.keyCode === 13 || e.keyCode === 27 || (e.keyCode >= 35 && e.keyCode <= 40)) {
        return true;
      }

      // Allow only numbers and +
      const char = String.fromCharCode(e.which || e.keyCode);
      if (!/[0-9+]/.test(char)) {
        e.preventDefault();
        return false;
      }
    });

    $(document).on('input', phoneFieldSelector, function() {
      const $this = $(this);
      let value = $this.val();
      const cleaned = cleanPhoneValue(value);
      if (value !== cleaned) {
        $this.val(cleaned);
      }
    });

    $(document).on('paste', phoneFieldSelector, function() {
      const $input = $(this);
      setTimeout(() => {
        let value = $input.val();
        const cleaned = cleanPhoneValue(value);
        if (value !== cleaned) {
          $input.val(cleaned);
        }
      }, 0);
    });

    // Also initialize phone fields when ACF adds new rows
    const acfInstance = (typeof window !== 'undefined' && window.acf) ? window.acf : null;
    if (acfInstance && acfInstance.addAction) {
      acfInstance.addAction('append', function($el) {
        $el.find(phoneFieldSelector).each(function() {
          restrictPhoneInput($(this));
        });
        // Also check by label for newly added fields
        findPhoneFieldsByLabel();

        // Initialise tooltips for dynamically added fields (e.g. repeaters).
        initDescriptionTooltips($el);
      });
    }

    // Set datepicker to French locale
    const setDatepickerFrench = function() {
      // French translations
      const frenchLocale = {
        closeText: 'Fermer',
        prevText: 'Précédent',
        nextText: 'Suivant',
        currentText: "Aujourd'hui",
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
          'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin',
          'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
        dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
        weekHeader: 'Sem.',
        firstDay: 1, // Monday
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
      };

      // Apply French locale to all datepickers
      if ($.datepicker) {
        $.datepicker.setDefaults(frenchLocale);
      }

      // Also apply to existing datepickers
      $('.acf-date-picker input.input').each(function() {
        const $input = $(this);
        if ($input.hasClass('hasDatepicker') || $input.data('datepicker')) {
          try {
            $input.datepicker('option', frenchLocale);
          } catch (e) {
            // Datepicker might not be ready yet
          }
        }
      });
    };

    // Set French locale on page load
    setDatepickerFrench();

    // Restrict date picker fields: birthdates to past only (excluding today), desired_entry_date to future only
    const birthdateFields = ['applicant_birthdate', 'spouse_birthdate', 'birthdate'];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Function to apply date restrictions to a datepicker input (only once)
    const applyDateRestrictions = function($input, fieldName) {
      if (!fieldName || !$input.length) return;

      // Check if already restricted to avoid re-applying
      if ($input.data('date-restricted')) return;

      try {
        // Apply French locale first
        setDatepickerFrench();

        // Check if it's a birthdate field
        if (birthdateFields.indexOf(fieldName) !== -1) {
          // Birthdate - past dates only, excluding today (maxDate: yesterday)
          if ($input.hasClass('hasDatepicker') || $input.data('datepicker')) {
            $input.datepicker('option', 'maxDate', yesterday);
            $input.data('date-restricted', true);
          }
        } else if (fieldName === 'desired_entry_date') {
          // Desired entry date - future dates only (minDate: tomorrow)
          if ($input.hasClass('hasDatepicker') || $input.data('datepicker')) {
            $input.datepicker('option', 'minDate', tomorrow);
            $input.data('date-restricted', true);
          }
        }
      } catch (e) {
        // Datepicker might not be ready yet, ignore
      }
    };

    // Function to initialize date restrictions for all date pickers
    const restrictDatePickers = function() {
      // Birthdate fields
      birthdateFields.forEach(function(fieldName) {
        $('.acf-field[data-name="' + fieldName + '"] .acf-date-picker input.input').each(function() {
          const $input = $(this);
          if (!$input.data('date-restricted')) {
            applyDateRestrictions($input, fieldName);
          }
        });
      });

      // Desired entry date
      $('.acf-field[data-name="desired_entry_date"] .acf-date-picker input.input').each(function() {
        const $input = $(this);
        if (!$input.data('date-restricted')) {
          applyDateRestrictions($input, 'desired_entry_date');
        }
      });
    };

    // Hook into datepicker before it shows (using beforeShow callback)
    $(document).on('click', '.acf-date-picker input.input', function() {
      const $input = $(this);
      const $field = $input.closest('.acf-field');
      const fieldName = $field.attr('data-name');

      if (fieldName && !$input.data('date-restricted')) {
        // Wait for datepicker to initialize, then apply restrictions once
        const checkInterval = setInterval(function() {
          if ($input.hasClass('hasDatepicker') || $input.data('datepicker')) {
            applyDateRestrictions($input, fieldName);
            clearInterval(checkInterval);
          }
        }, 50);

        // Stop checking after 1 second
        setTimeout(function() {
          clearInterval(checkInterval);
        }, 1000);
      }
    });

    // Initialize on page load
    setTimeout(function() {
      restrictDatePickers();
    }, 1000);

    // Re-initialize when ACF adds new rows (for repeater birthdate fields)
    if (acfInstance && acfInstance.addAction) {
      acfInstance.addAction('append', function($el) {
        // Add animation class to newly added repeater rows
        if ($el && $el.hasClass('acf-row')) {
          // Force reflow to ensure initial state is applied
          $el[0].offsetHeight;
          $el.addClass('repeater-row-new');
          // Remove class after animation completes
          setTimeout(function() {
            $el.removeClass('repeater-row-new');
          }, 400);
        }

        setTimeout(function() {
          setDatepickerFrench();
          restrictDatePickers();
        }, 500);
      });
    }

    // Open datepicker when clicking on the field label (UX for mobile/desktop)
    $(document).on('click', '.acf-field-date-picker .acf-label label', function() {
      const $field = $(this).closest('.acf-field-date-picker');
      const $input = $field.find('.acf-date-picker input.input').first();
      if ($input.length) {
        $input.trigger('focus').trigger('click');
      }
    });

    // Add animation class when datepicker is shown
    $(document).on('focus', '.acf-date-picker input.input', function() {
      // Wait for jQuery UI to create the datepicker element
      const checkDatepicker = setInterval(function() {
        const $datepicker = $('#ui-datepicker-div.acf-ui-datepicker');
        if ($datepicker.length && !$datepicker.hasClass('datepicker-animate')) {
          // Force reflow to ensure initial state is applied
          $datepicker[0].offsetHeight;
          // Add class to trigger transition
          $datepicker.addClass('datepicker-animate');
          clearInterval(checkDatepicker);
        }
      }, 10);

      // Stop checking after 500ms
      setTimeout(function() {
        clearInterval(checkDatepicker);
      }, 500);
    });

    // Focus input / open Select2 when clicking on the field wrapper
    $('.acf-field-text, .acf-field-email, .acf-field-select, .acf-field[data-type="select"]')
      .not('.input_focus')
      .on('click', function (event) {
        event.preventDefault();

        $('.acf-field.input_focus').removeClass('input_focus');

        const $field = $(this);
        $field.find('.acf-error-message').remove();
        $field.addClass('input_focus');

        const $input = $field.find('input, textarea').first();
        const $select = $field.find('select').first();

        if ($select.length) {
          if ($.fn.select2 && $select.hasClass('select2-hidden-accessible')) {
            $select.select2('open');
          } else {
            $select.trigger('focus').trigger('click');
          }
        } else if ($input.length) {
          $input.trigger('focus');
        }

        return false;
      });

    // Global ACF overlay & spinner
    const initGlobalOverlay = () => {
      let overlay = document.getElementById('acf-global-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'acf-global-overlay';
        overlay.innerHTML = `<div class="acf-global-spinner" aria-label="Loading">
          <svg width="126" height="100" viewBox="0 0 126 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <mask id="acf-mask1">
                <rect id="acf-maskRect1" x="0" y="50" width="126" height="50" fill="white" />
              </mask>
              <mask id="acf-mask2">
                <rect id="acf-maskRect2" x="0" y="50" width="126" height="50" fill="white" />
              </mask>
            </defs>
            <path d="M125.099 0H107.301V13.6811H107.302L107.301 13.6817L116.2 22.5785L125.098 13.6811H125.099V0Z" fill="currentColor"/>
            <path d="M53.651 13.6817L62.5492 22.5785L71.4473 13.6811H71.4486V0H53.6505V13.6811H53.6511L53.651 13.6817Z" fill="currentColor"/>
            <path d="M8.89879 22.5785L17.797 13.6811H17.7982V0H0V13.6811H0.00123771L0.000618853 13.6817L8.89879 22.5785Z" fill="currentColor"/>
            <path d="M111.697 61.4129C106.078 67.6715 98.7059 71.1177 90.9383 71.1177C83.1763 71.1177 75.7898 67.6688 70.1502 61.4129L62.5485 52.9443L54.9505 61.4129C49.3309 67.6715 41.959 71.1177 34.1915 71.1177C26.4295 71.1177 19.043 67.6688 13.4033 61.4129L8.8595 56.3502L2.7439 61.8386L7.29504 66.9076C14.5211 74.9204 24.0718 79.3338 34.1915 79.3338C44.324 79.3338 53.8657 74.9185 61.0643 66.9002L62.5485 65.2447L64.0419 66.9076C71.2679 74.9204 80.8187 79.3338 90.9383 79.3338C101.071 79.3338 110.612 74.9185 117.811 66.9012L122.355 61.8386L116.239 56.3502L111.697 61.4129Z" fill="currentColor" mask="url(#acf-mask1)"/>
            <path d="M90.9018 91.7839C81.4969 91.7839 72.6153 88.4353 65.2161 82.0982L62.5394 79.8043L59.8663 82.1037C52.5054 88.4371 43.6256 91.7839 34.1879 91.7839C24.7811 91.7839 15.8995 88.4353 8.50033 82.0982L3.15778 88.3377C12.0649 95.9667 22.7955 100 34.1879 100C44.4935 100 54.2302 96.7207 62.5503 90.482C70.894 96.7197 80.629 100 90.9018 100C102.334 100 113.067 95.9648 121.939 88.3322L116.582 82.1037C109.221 88.4371 100.341 91.7839 90.9018 91.7839Z" fill="currentColor" mask="url(#acf-mask2)"/>
          </svg>
        </div>`;
        document.body.appendChild(overlay);
      }

      const blurTarget = document.querySelector('.acf-blur-target');

      const animateOverlaySpinner = () => {
        // Mirror the home preloader animation if GSAP is available.
        /* global gsap */
        if (typeof gsap === 'undefined') return;

        const svg = overlay.querySelector('svg');
        if (!svg) return;

        const pathDots = Array.from(svg.querySelectorAll('path')).slice(0, 3);

        // Reset initial state
        gsap.set(pathDots, {
          y: -200,
          opacity: 0,
        });

        gsap.to(pathDots, {
          y: 0,
          opacity: 1,
          duration: 2,
          stagger: 0.05,
          ease: 'bounce.out',
        });

        [
          { selector: '#acf-maskRect1', from: { x: -126, opacity: 0 }, to: { x: 0, opacity: 1, duration: 1.5 } },
          { selector: '#acf-maskRect2', from: { x: 126, opacity: 0 }, to: { x: 0, opacity: 1, duration: 1.5 } },
        ].forEach(({ selector, from, to }) => {
          const target = svg.querySelector(selector);
          if (!target) return;
          gsap.fromTo(
            target,
            { ...from, ease: 'power2.inOut' },
            to
          );
        });
      };

      const showOverlay = () => {
        animateOverlaySpinner();
        overlay.classList.add('is-active');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (blurTarget) blurTarget.classList.add('acf-blurred');
      };

      const hideOverlay = () => {
        overlay.classList.remove('is-active');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (blurTarget) blurTarget.classList.remove('acf-blurred');
      };

      const bindAcfHooks = () => {
        /* global acf */
        if (typeof acf === 'undefined' || !acf.addAction) return;

        acf.addAction('validation_begin', showOverlay);
        acf.addAction('validation_failure', hideOverlay);
        acf.addAction('submit_success', hideOverlay);
        acf.addAction('submit_failure', hideOverlay);
        // Guard: ensure overlay is removed when validation ends (covers edge cases)
        acf.addAction('validation_end', hideOverlay);
      };

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.acf-form button[type="submit"], .acf-form input[type="submit"]');
        if (btn) showOverlay();
      });

      // Hide overlay if native HTML5 validation blocks submission (e.g., iOS Safari)
      document.addEventListener(
        'invalid',
        () => {
          hideOverlay();
        },
        true
      );

      // Also guard on submit: if form is invalid, hide overlay
      document.addEventListener(
        'submit',
        (event) => {
          const form = event.target;
          if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) {
            hideOverlay();
          }
        },
        true
      );

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') hideOverlay();
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindAcfHooks);
      } else {
        bindAcfHooks();
      }
    };

    initGlobalOverlay();

    // Scroll to success message after form submission
    const scrollToSuccessMessage = () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('updated') === 'true') {
        const successMessage = document.querySelector('.cf-form-success');
        if (successMessage) {
          // Small delay to ensure DOM is ready
          setTimeout(() => {
            const elementTop = successMessage.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementTop - 50;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }, 100);
        }
      }
    };

    // Run on page load if success param is present
    scrollToSuccessMessage();

    // Update ordinal labels for housing household members (frontend repeater)
    const initHouseholdOrdinals = () => {
      const messageSelector = '.acf-field-message[data-key="field_housing_household_title"]';
      const spouseFieldSelector = '.acf-field[data-name="applicant_live_with_spouse"]';

      // Get the starting number based on whether spouse is included
      const getStartingNumber = () => {
        const $spouseField = $(spouseFieldSelector);
        if ($spouseField.length) {
          // Check if the checkbox is checked (ACF true/false fields use a checkbox)
          const $checkbox = $spouseField.find('input[type="checkbox"]');
          const isChecked = $checkbox.length && $checkbox.is(':checked');

          // Also check the hidden input value as fallback
          const $hiddenInput = $spouseField.find('input[type="hidden"]');
          const hiddenValue = $hiddenInput.length ? $hiddenInput.val() : null;

          // If spouse field is true (checked or value is 1), start at 3; if false, start at 2
          const spouseValue = isChecked || hiddenValue === '1' || hiddenValue === 1;
          return spouseValue ? 3 : 2;
        }
        // Default to 3 if field not found (backward compatibility)
        return 3;
      };

      const formatOrdinal = (index) => {
        const startNum = getStartingNumber();
        const num = index + startNum; // start at 2e or 3e depending on spouse field
        const suffix = num === 1 ? '<sup>er</sup>' : '<sup>e</sup>'; // 1er (masc), otherwise e
        return `${num}${suffix}`;
      };

      const applyOrdinals = () => {
        const messages = document.querySelectorAll(messageSelector);
        messages.forEach((fieldEl, index) => {
          const p = fieldEl.querySelector('.acf-input p') || fieldEl.querySelector('.acf-input');
          if (!p) return;

          if (!p.dataset.originalText) {
            p.dataset.originalText = p.innerHTML;
          }
          const original = p.dataset.originalText || p.innerHTML || '';
          if (original.includes('%s')) {
            p.innerHTML = original.replace('%s', formatOrdinal(index));
          }
        });
      };

      applyOrdinals();

      const acfInstance = (typeof window !== 'undefined' && window.acf) ? window.acf : null;
      if (acfInstance && acfInstance.addAction) {
        acfInstance.addAction('append', () => {
          applyOrdinals();
        });
      }

      // Re-apply ordinals when spouse field changes
      $(document).on('change', spouseFieldSelector + ' input[type="checkbox"]', () => {
        // Wait a bit for ACF to update the field state
        setTimeout(() => {
          applyOrdinals();
        }, 50);
      });

      // Also listen for clicks on the switch (ACF UI toggle)
      $(document).on('click', spouseFieldSelector + ' .acf-switch, ' + spouseFieldSelector + ' label', () => {
        setTimeout(() => {
          applyOrdinals();
        }, 100);
      });
    };

    initHouseholdOrdinals();

    // Restrict number fields to only allow digits (0-9)
    // HTML5 number inputs allow e, E, +, -, . characters, which we want to block
    const numberFieldSelector = '.acf-field-number input[type="number"], .acf-field[data-type="number"] input[type="number"]';

    // Function to clean number input value (keep only digits)
    const cleanNumberValue = function(value) {
      if (!value) return '';
      // Remove everything except digits 0-9
      return String(value).replace(/[^0-9]/g, '');
    };

    // Function to check if a key should be allowed (only digits)
    const isAllowedKey = function(e) {
      // Allow control keys (backspace, delete, tab, escape, enter, arrow keys, etc.)
      if (e.ctrlKey || e.metaKey || e.altKey || e.keyCode === 8 || e.keyCode === 9 ||
          e.keyCode === 13 || e.keyCode === 27 || (e.keyCode >= 35 && e.keyCode <= 40) ||
          e.keyCode === 46) {
        return true;
      }

      // Use e.key if available (modern browsers), otherwise fall back to keyCode
      const key = e.key || String.fromCharCode(e.which || e.keyCode);

      // Only allow digits 0-9
      if (/^[0-9]$/.test(key)) {
        return true;
      }

      // Also check keyCode for digits (48-57 for 0-9 on main keyboard, 96-105 for numpad)
      if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
        return true;
      }

      return false;
    };

    // Function to restrict number input
    const restrictNumberInput = function($input) {
      if ($input.data('number-restricted')) {
        return; // Already restricted
      }
      $input.data('number-restricted', true);

      // Prevent invalid characters on keydown (more reliable than keypress)
      $input.on('keydown', function(e) {
        // Only allow digits and control keys
        if (!isAllowedKey(e)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });

      // Also prevent on keypress as backup
      $input.on('keypress', function(e) {
        // Only allow digits and control keys
        if (!isAllowedKey(e)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });

      // Clean on input (remove e, E, + if somehow entered) - more aggressive
      $input.on('input', function() {
        const $this = $(this);
        let value = $this.val();
        const cleaned = cleanNumberValue(value);
        if (value !== cleaned) {
          // Use native setter to trigger change event
          this.value = cleaned;
          $this.trigger('change');
        }
      });

      // Clean on paste
      $input.on('paste', function() {
        const $input = $(this);
        setTimeout(() => {
          let value = $input.val();
          const cleaned = cleanNumberValue(value);
          if (value !== cleaned) {
            $input.val(cleaned);
            $input.trigger('change');
          }
        }, 0);
      });

      // Also clean on blur as final safety check
      $input.on('blur', function() {
        const $this = $(this);
        let value = $this.val();
        const cleaned = cleanNumberValue(value);
        if (value !== cleaned) {
          $this.val(cleaned);
          $this.trigger('change');
        }
      });
    };

    // Apply to existing number fields
    $(numberFieldSelector).each(function() {
      restrictNumberInput($(this));
    });

    // Use event delegation for dynamically added fields (repeaters, etc.)
    $(document).on('keydown', numberFieldSelector, function(e) {
      // Only allow digits and control keys
      if (!isAllowedKey(e)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });

    $(document).on('keypress', numberFieldSelector, function(e) {
      // Only allow digits and control keys
      if (!isAllowedKey(e)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });

    $(document).on('input', numberFieldSelector, function() {
      const $this = $(this);
      let value = $this.val();
      const cleaned = cleanNumberValue(value);
      if (value !== cleaned) {
        this.value = cleaned;
        $this.trigger('change');
      }
    });

    $(document).on('paste', numberFieldSelector, function() {
      const $input = $(this);
      setTimeout(() => {
        let value = $input.val();
        const cleaned = cleanNumberValue(value);
        if (value !== cleaned) {
          $input.val(cleaned);
          $input.trigger('change');
        }
      }, 0);
    });

    // Also clean on blur as final safety check
    $(document).on('blur', numberFieldSelector, function() {
      const $this = $(this);
      let value = $this.val();
      const cleaned = cleanNumberValue(value);
      if (value !== cleaned) {
        $this.val(cleaned);
        $this.trigger('change');
      }
    });

    // Also initialize number fields when ACF adds new rows
    if (acfInstance && acfInstance.addAction) {
      acfInstance.addAction('append', function($el) {
        $el.find(numberFieldSelector).each(function() {
          restrictNumberInput($(this));
        });
      });
    }

    // Scroll to top when clicking on .acf-field-message
    $(document).on('click', '.acf-field-message', function() {
      const $field = $(this);
      const fieldTop = $field.offset().top;
      const scrollOffset = 30; // Position at top of viewport

      $('html, body').animate({
        scrollTop: fieldTop - scrollOffset,
      }, 500); // 500ms smooth scroll
    });

    // Make accept_terms label clickable to open link
    $(document).on('click', '.acf-field-true-false[data-name="accept_terms"] .acf-label label', function(e) {
      // Get the link URL from themeVars (ACF options)
      const linkUrl = typeof themeVars !== 'undefined' && themeVars.termsConditionsLink
        ? themeVars.termsConditionsLink
        : null;

      if (linkUrl) {
        e.preventDefault();
        e.stopPropagation();
        window.open(linkUrl, '_blank');
      }
    });

    // Animate conditional fields when they appear or disappear
    const animateConditionalFields = function(forceCheck) {
      // Watch for fields with conditional logic that become visible or hidden
      $('.acf-field[data-conditions]').each(function() {
        const $field = $(this);
        const wasHidden = $field.data('was-hidden');

        // More reliable check: use computed style and check for acf-hidden class
        const hasAcfHidden = $field.hasClass('acf-hidden');
        const computedDisplay = window.getComputedStyle($field[0]).display;
        const isCurrentlyHidden = hasAcfHidden || computedDisplay === 'none';

        // Skip if currently animating (unless forced)
        if (!forceCheck && ($field.hasClass('conditional-field-show') || $field.hasClass('conditional-field-hide'))) {
          return;
        }

        // If field was hidden and is now visible, animate it in
        if (wasHidden === true && !isCurrentlyHidden) {
          // Remove any hide animation class and reset styles
          $field.removeClass('conditional-field-hide');
          $field.css('display', '').css('visibility', '').css('opacity', '');
          // Remove acf-hidden class if present (ACF might have left it)
          $field.removeClass('acf-hidden');
          // Force reflow to ensure initial state is applied
          $field[0].offsetHeight;
          $field.addClass('conditional-field-show');
          // Update state immediately to prevent double-triggering
          $field.data('was-hidden', false);
          // Remove class after animation completes
          setTimeout(function() {
            $field.removeClass('conditional-field-show');
          }, 400);
        }
        // If field was visible and is now hidden, animate it out
        else if (wasHidden === false && isCurrentlyHidden) {
          // Temporarily make it visible for animation
          const originalDisplay = $field.css('display');
          $field.css('display', 'block').css('visibility', 'hidden');
          // Force reflow
          $field[0].offsetHeight;
          // Make visible and add hide animation
          $field.css('visibility', 'visible');
          $field.addClass('conditional-field-hide');
          // Update state immediately to prevent double-triggering
          $field.data('was-hidden', true);
          // After animation, restore original state
          setTimeout(function() {
            $field.removeClass('conditional-field-hide');
            $field.css('display', originalDisplay).css('visibility', '');
          }, 300);
        }
        // Always update the state if not animating
        else if (!$field.hasClass('conditional-field-show') && !$field.hasClass('conditional-field-hide')) {
          $field.data('was-hidden', isCurrentlyHidden);
        }
      });
    };

    // Initialize hidden state for all conditional fields
    $('.acf-field[data-conditions]').each(function() {
      const $field = $(this);
      const hasAcfHidden = $field.hasClass('acf-hidden');
      const computedDisplay = window.getComputedStyle($field[0]).display;
      const isHidden = hasAcfHidden || computedDisplay === 'none';
      $field.data('was-hidden', isHidden);
    });

    // Watch for changes in conditional fields
    // Use MutationObserver to detect when ACF shows/hides fields
    const conditionalFieldsObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
          const $target = $(mutation.target);
          if ($target.hasClass('acf-field') && $target.attr('data-conditions')) {
            // Use multiple checks to catch the change
            setTimeout(animateConditionalFields, 10);
            setTimeout(animateConditionalFields, 50);
          }
        }
      });
    });

    // Observe all conditional fields
    $('.acf-field[data-conditions]').each(function() {
      conditionalFieldsObserver.observe(this, {
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    });

    // Also observe the form container for any field changes
    const formObserver = new MutationObserver(function() {
      setTimeout(animateConditionalFields, 50);
    });

    // Observe the form for any changes
    $('form.acf-form').each(function() {
      formObserver.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    });

    // Also check on input changes (when conditional logic is triggered)
    // Use multiple timeouts to catch ACF's conditional logic processing
    $(document).on('change', '.acf-field input, .acf-field select, .acf-field textarea', function() {
      // First, capture current state of all conditional fields BEFORE ACF processes
      $('.acf-field[data-conditions]').each(function() {
        const $field = $(this);
        const hasAcfHidden = $field.hasClass('acf-hidden');
        const computedDisplay = window.getComputedStyle($field[0]).display;
        const isHidden = hasAcfHidden || computedDisplay === 'none';
        // Only update if not currently animating
        if (!$field.hasClass('conditional-field-show') && !$field.hasClass('conditional-field-hide')) {
          $field.data('was-hidden', isHidden);
        }
      });

      // Then check multiple times after ACF processes conditional logic
      // Use requestAnimationFrame for better timing
      requestAnimationFrame(function() {
        setTimeout(function() {
          animateConditionalFields(true);
        }, 0);
      });
      setTimeout(function() {
        animateConditionalFields(true);
      }, 50);
      setTimeout(function() {
        animateConditionalFields(true);
      }, 100);
      setTimeout(function() {
        animateConditionalFields(true);
      }, 200);
      setTimeout(function() {
        animateConditionalFields(true);
      }, 300);
      setTimeout(function() {
        animateConditionalFields(true);
      }, 400);
    });

    // Check on page load for any fields that should be visible
    setTimeout(animateConditionalFields, 100);

    // Try to hook into ACF's conditional logic system if available
    if (acfInstance && acfInstance.addAction) {
      // Hook into ACF's conditional logic change event if it exists
      // This might be called when conditional fields are shown/hidden
      // Note: ACF passes field object, not jQuery object
      acfInstance.addAction('show_field', function(field) {
        if (field && field.$el) {
          const $field = field.$el;
          if ($field.attr('data-conditions')) {
            // Field is being shown - animate it in
            $field.removeClass('conditional-field-hide');
            $field.css('display', '').css('visibility', '').css('opacity', '');
            $field.removeClass('acf-hidden');
            // Force reflow to ensure initial state is applied
            $field[0].offsetHeight;
            $field.addClass('conditional-field-show');
            $field.data('was-hidden', false);
            // Remove class after animation completes
            setTimeout(function() {
              $field.removeClass('conditional-field-show');
            }, 400);
          }
        }
      });

      acfInstance.addAction('hide_field', function(field) {
        if (field && field.$el) {
          const $field = field.$el;
          if ($field.attr('data-conditions')) {
            // Field is being hidden
            const wasHidden = $field.data('was-hidden');
            if (wasHidden === false) {
              setTimeout(function() {
                const originalDisplay = $field.css('display');
                $field.css('display', 'block').css('visibility', 'hidden');
                $field[0].offsetHeight;
                $field.css('visibility', 'visible');
                $field.addClass('conditional-field-hide');
                $field.data('was-hidden', true);
                setTimeout(function() {
                  $field.removeClass('conditional-field-hide');
                  $field.css('display', originalDisplay).css('visibility', '');
                }, 300);
              }, 10);
            }
          }
        }
      });

      (function () {
        if (navigator.userAgent && /Edg\//.test(navigator.userAgent)) {
          document.documentElement.classList.add('is-edge');
        }
      })();
    }
  });
};
